export const ROUTE_NAMES = {
  PAUSE_SUBSCRIPTION: 'pauseSubscription',
  BLOCK_CANCEL_SUBSCRIPTION: 'blockCancelSubscription',
};
